import { data } from '../../svg/Forest/data';
import { makeIcon } from '../makeIcon';

export const Forest = makeIcon(data, 'forest', 'Forest');

export default Forest;
